export default __webpack_public_path__ + "static/media/icons-tp-desks.3be056d0.svg";